import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/internal/observable/of';
import { CompanyAddress } from '../_models/companyAddress';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompanyAddressService {
  private apiBaseUrl = environment.apiBaseUrl;
  private companyAddresses: CompanyAddress[] | null = null;

  constructor(private http: HttpClient) {}

  getCompanyAddresses(allMultifarm = false, skip = false): Observable<CompanyAddress[]> {
    if (skip && this.companyAddresses) {
      return of(this.companyAddresses);
    }

    let all = '';
    if (allMultifarm) {
      all = '?all=' + allMultifarm;
    }
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/companyAddresses' + all).pipe(
      map((response) => {
        this.companyAddresses = response;
        return response;
      })
    );
  }

  getCompanyAddressesByCompanyId(companyId: number): Observable<CompanyAddress[]> {
    return this.http
      .get<
        CompanyAddress[]
      >(this.apiBaseUrl + 'api/private/v1/companyAddresses?companyIds=' + companyId)
      .pipe(map((response) => response));
  }

  getCompanyAddress(id: number): Observable<CompanyAddress> {
    return this.http
      .get<CompanyAddress>(this.apiBaseUrl + 'api/private/v1/companyAddresses/' + id)
      .pipe(map((response) => response));
  }

  saveCompanyAddress(companyAddressItem): Observable<CompanyAddress> {
    const companyAddress = { ...companyAddressItem };
    delete companyAddress.lastUpdated;
    delete companyAddress.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    companyAddress.companyId = companySelected ? companySelected.id : null;

    if (companyAddress.user != null && companyAddress.user.id != null) {
      companyAddress.user = { id: companyAddress.user.id };
    }
    if (companyAddress.id) {
      return this.http
        .put<CompanyAddress>(
          this.apiBaseUrl + 'api/private/v1/companyAddresses/' + companyAddress.id,
          companyAddress
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<CompanyAddress>(this.apiBaseUrl + 'api/private/v1/companyAddresses/', companyAddress)
        .pipe(map((response) => response));
    }
  }

  deleteCompanyAddress(id: number): Observable<CompanyAddress> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/companyAddresses/' + id).pipe(
      map((response) => {
        return { id } as CompanyAddress;
      })
    );
  }
}
